export const INPUT_ID = 'Input';
export const GROUP_ID = 'input-group';
export const PREFIX_ID = 'input-prefix';
export const SUFFIX_ID = 'input-suffix';
export const DEFAULT_INPUT_ROLE = 'textbox';
